import { HStack, StackProps, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { useSubscribeCartStoreShallow } from '../hooks/cartStoreHooks';
import { getTotalPriceWithShipping } from '../lib/totalPriceHelpers';
import { cartStoreSelectors } from '../selectors';

type CartTotalPriceProps = StackProps & {
  shippingCost?: number;
};

const CartTotalPriceWithShipping = ({ shippingCost, ...props }: CartTotalPriceProps) => {
  const { t } = useTranslation();
  const subtotalPrice = useSubscribeCartStoreShallow(cartStoreSelectors.totalPrice);

  const totalPrice = getTotalPriceWithShipping(subtotalPrice.withDiscount, shippingCost);

  return (
    <VStack
      spacing={2}
      w='full'
      {...props}
    >
      <HStack
        align='baseline'
        w='full'
      >
        <Text
          fontSize='lg'
          fontWeight='semibold'
          mr='auto'
        >
          {t('store.cart.pricing.subtotal')}
        </Text>

        {subtotalPrice.savings > 0 && (
          <Text
            fontSize='sm'
            textDecoration='line-through'
          >
            ${subtotalPrice.raw.toFixed(2)}
          </Text>
        )}
        <Text
          fontSize='lg'
          fontWeight='bold'
        >
          ${subtotalPrice.withDiscount.toFixed(2)}
        </Text>
      </HStack>

      {shippingCost && (
        <HStack
          justify='space-between'
          w='full'
        >
          <Text>{t('store.cart.pricing.shipping')}</Text>
          <Text>{shippingCost.toFixed(2)}</Text>
        </HStack>
      )}

      <HStack
        align='baseline'
        w='full'
      >
        <Text
          fontSize='lg'
          fontWeight='semibold'
          mr='auto'
        >
          {t('store.cart.pricing.total')}
        </Text>

        <Text
          fontSize='xl'
          fontWeight='bold'
        >
          ${totalPrice.toFixed(2)}
        </Text>
      </HStack>
    </VStack>
  );
};

export default CartTotalPriceWithShipping;
